import { Button, Modal, Space } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  errorPayload: string[];
  onClose: () => any;
}

export function UsersUploadFailedModal(props: Props) {
  const { onClose } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'users.upload.failed',
  });

  const errors = props.errorPayload;

  return (
    <Modal
      title={t('title')}
      visible
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          {t('close')}
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large">
        {errors}
      </Space>
    </Modal>
  );
}
